import axios from 'axios';

export default {
  getAll() {
    return axios.get('/v1/revise_periods');
  },
  checkActive() {
    return axios.get('/v1/revise_periods/check_active');
  },
  updatePeriod(id, data) {
    return axios.put(`/v1/revise_periods/${id}`, data);
  },
  getTolerance() {
    return axios.get('/v2/spending/tolerance');
  },
  updateTolerance(data) {
    return axios.patch('/v2/spending/tolerance', data);
  },
  getAdhoc() {
    return axios.get('/v1/io/adhoc-config');
  },
  updateAdhoc(data) {
    return axios.put('/v1/io/update-adhoc-config', data);
  },
  getPODate(params = {}) {
    return axios.get('/v1/purchasing-orders/upload/automated-dates', {
      params
    });
  },
  getNonPODate(params = {}) {
    return axios.get('/v1/non-purchasing-orders/upload/automated-dates', {
      params
    });
  },
  getPOTime() {
    return axios.patch('/v1/purchasing-orders/upload/automated-time');
  },
  getNonPOTime() {
    return axios.patch('/v1/non-purchasing-orders/upload/automated-time');
  },
  updatePODate(data) {
    return axios.patch('/v1/purchasing-orders/upload/automated-dates', data);
  },
  updatePOTime(data) {
    return axios.patch('/v1/purchasing-orders/upload/automated-time', data);
  },
  updateNonPODate(data) {
    return axios.patch(
      '/v1/non-purchasing-orders/upload/automated-dates',
      data
    );
  },
  updateNonPOTime(data) {
    return axios.patch('/v1/non-purchasing-orders/upload/automated-time', data);
  },
  getLoginBlock() {
    return axios.get('/v1/login-blocked-duration');
  },
  updateLoginBlock(data) {
    return axios.patch('/v1/login-blocked-duration', data);
  },
  getConfigEmail() {
    return axios.get('/v1/help-center/config-email');
  },
  updateConfigEmail(data) {
    return axios.put('/v1/help-center/update-config-email', data);
  },
  getLockBudget() {
    return axios.get('/v1/config/budget-period');
  },
  updateLockBudget(data) {
    return axios.put('/v1/config/budget-period/1', data);
  },
  getReminderBudget(params = {}) {
    return axios.get('/v1/config/budget-period/popup', { params });
  }
};
